import React, { useRef } from 'react';

import { withEventScope } from '@repo/event-processor';
import ArrowIcon from '@repo/ui/components/Icon/ArrowIcon';
import { themeStyle } from '@repo/ui/theming';

import useListScroll from 'components/hooks/useListScroll';
import ResponsiveSpacer from 'components/ResponsiveSpacer/ResponsiveSpacer';

import Card from './Card';
import { OuterRowWrapper, RowWrapper, ScrollButton } from './styles';
import { PresetCardRowProps } from './types';

const PresetCardRow: React.FC<PresetCardRowProps> = (props) => {
  const listRef = useRef<HTMLDivElement>(null);

  const {
    canScrollLeft,
    canScrollRight,
    updateScrollState,
    scrollLeft,
    scrollRight,
  } = useListScroll(listRef, 275);

  return (
    <OuterRowWrapper>
      <RowWrapper ref={listRef} onScroll={updateScrollState}>
        <ResponsiveSpacer dw="8px" mw="4px" />
        {props.presets.map(({ id, ...preset }) => {
          return (
            <Card
              key={id}
              isActive={id === props.activePresetId}
              onClick={(): void => props.onPresetClick(id)}
              {...preset}
            />
          );
        })}
        <ResponsiveSpacer dw="21px" mw="4px" />
      </RowWrapper>
      {canScrollLeft && (
        <ScrollButton align="left" onClick={scrollLeft}>
          <i style={{ transform: 'rotate(180deg)', marginRight: '3px' }}>
            <ArrowIcon
              height="14px"
              theme={{ color: themeStyle.varInkMedium }}
            />
          </i>
        </ScrollButton>
      )}
      {canScrollRight && (
        <ScrollButton align="right" onClick={scrollRight}>
          <i style={{ marginLeft: '3px' }}>
            <ArrowIcon
              height="14px"
              theme={{ color: themeStyle.varInkMedium }}
            />
          </i>
        </ScrollButton>
      )}
    </OuterRowWrapper>
  );
};

export default withEventScope(PresetCardRow, { module: 'presetCardRow' });
